module.exports = __webpack_public_path__ + "public/images/scienceAndNature.c62e83d09f5bb601bba393b624053d1c.jpg";